module.exports = __webpack_public_path__ + "img/ranking.234ba081.png";